import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_PREFIX, RESOURCES, filtersToParams } from 'rio-core';
import { SelectedFilters } from 'rio-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Prompt, PromptsResponse } from './models';

@Injectable()
export class PromptsService {
  API_PREFIX = inject(API_PREFIX);
  httpClient = inject(HttpClient);

  getPrompts(organizationId: string, filters?: SelectedFilters): Observable<Prompt[]> {
    const url = `${this.API_PREFIX}${RESOURCES.PROMPTS.prompts(organizationId)}`;

    const params = filtersToParams(filters);

    return this.httpClient.get<PromptsResponse>(url, { params }).pipe(
      map(response =>
        response.prompts.map(prompt => ({
          type: 'prompt',
          id: prompt.id,
          externalId: prompt.external_id,
          name: prompt.name,
          categories: prompt.categories,
          activatedVersion: prompt.activated_version,
          textLength: prompt.text_length,
          allowTextLengthModification: prompt.allow_text_length_modification,
          quotePreservation: prompt.quote_preservation,
          chains: prompt.chains,
          lastEdited: prompt.last_edited,
          lastUsed: prompt.last_used,
          usage: prompt.usage,
          inputType: prompt.input_type,
        })),
      ),
    );
  }
}
